import React from "react";
import { gameActor } from "../hooks/useGameMachine.js";

/**
 * U04 — dev-only map selector.
 *
 * Lists every map id declared in the active adventure's manifest and
 * jumps to it via `LOAD_MAP`. Intended for playtest/debug sessions
 * where the author wants to skip past floor_01 without dying to the
 * boss or editing a save file. Gated behind `import.meta.env.DEV`
 * in `MainMenu`, so production bundles never surface the button.
 */
interface Props {
  readonly maps: readonly string[];
  /** Called after a jump is issued, so the pause overlay can close too. */
  readonly onClose: () => void;
  /** Called on Back — returns to the main menu without jumping. */
  readonly onBack: () => void;
}

export function DevMapSelector({ maps, onClose, onBack }: Props) {
  const jump = (mapId: string) => {
    gameActor.send({ type: "CLOSE_MENU" });
    gameActor.send({ type: "LOAD_MAP", mapId });
    onClose();
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        minWidth: 280,
      }}
    >
      <h2
        style={{
          color: "white",
          fontFamily: "monospace",
          margin: 0,
          fontSize: 16,
          letterSpacing: 1,
        }}
      >
        JUMP TO MAP
      </h2>
      <div
        style={{
          fontFamily: "monospace",
          fontSize: 11,
          color: "rgba(255,255,255,0.55)",
          marginTop: -4,
          marginBottom: 4,
        }}
      >
        Dev-only. Loads the map fresh — your current party + world state carry over.
      </div>
      {maps.length === 0 ? (
        <div
          style={{
            fontFamily: "monospace",
            fontSize: 12,
            color: "rgba(255,255,255,0.55)",
            padding: "12px 0",
          }}
        >
          Active adventure manifest has no <code>maps</code> list.
        </div>
      ) : (
        maps.map((mapId) => (
          <button
            key={mapId}
            onClick={() => jump(mapId)}
            style={{
              background: "#333",
              color: "white",
              border: "1px solid rgba(255,255,255,0.3)",
              borderRadius: 4,
              padding: "6px 16px",
              fontFamily: "monospace",
              fontSize: 12,
              cursor: "pointer",
              textAlign: "left",
            }}
          >
            {mapId}
          </button>
        ))
      )}
      <button
        onClick={onBack}
        style={{
          background: "#222",
          color: "#aab",
          border: "1px solid rgba(255,255,255,0.2)",
          borderRadius: 4,
          padding: "6px 16px",
          fontFamily: "monospace",
          fontSize: 12,
          cursor: "pointer",
          marginTop: 6,
        }}
      >
        Back
      </button>
    </div>
  );
}
